import PropTypes from 'prop-types';
import React, { useState } from 'react';

const axios = require('axios').default;

const maskedPhone = (phone) => `(xxx) xxx-xx${phone.replace(/\D/g, '').slice(-2)}`;

const errorMessage = (data) => {
  if(Array.isArray(data) && data.length > 0){ return data.join(', '); }
  return 'Something went wrong. Please try again.';
};

const PhoneVerification = ({ csrfToken, phone, verified: initiallyVerified, codeSent: initiallyCodeSent, unsentReason, notice, onConfirmed }) => {
  const [verified, setVerified] = useState(initiallyVerified);
  const [codeSent, setCodeSent] = useState(Boolean(initiallyCodeSent));
  const [code, setCode] = useState('');
  const [message, setMessage] = useState(initiallyCodeSent === false ? unsentReason : notice);

  const request = (method, data) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    return axios[method]('/phone_verification', data)
      .catch((error) => {
        setMessage(errorMessage(error.response?.data));
        return null;
      });
  };

  const submitCode = () => request('patch', { phone_verification_code: code }).then((response) => {
    if(response){ setVerified(true); setMessage(null); onConfirmed(response.data); }
  });

  const resend = () => request('post').then((response) => {
    if(response){ setCodeSent(true); setMessage(response.data.phone_code_notice || null); }
  });

  if(verified){
    return <p className="settings-helper text-success" data-phone-verified>&#10003; Confirmed</p>;
  }

  return (
    <div data-phone-verification>
      <p className="settings-helper">
        {codeSent ? `Enter the code we texted to ${maskedPhone(phone)}` : 'Confirm your number — send a code'}
      </p>
      <div className="d-flex" style={{ gap: 8 }}>
        <input
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={6}
          className="form-control settings-input"
          id="user-phone-code"
          aria-label="Confirmation code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <button type="button" className="btn btn-primary" onClick={submitCode} disabled={code.length !== 6}>Confirm</button>
        <button type="button" className="btn btn-link" onClick={resend}>Send code</button>
      </div>
      {message && <p className="settings-helper" role="status">{message}</p>}
    </div>
  );
};

PhoneVerification.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  verified: PropTypes.bool.isRequired,
  codeSent: PropTypes.bool,
  unsentReason: PropTypes.string,
  notice: PropTypes.string,
  onConfirmed: PropTypes.func.isRequired,
};

PhoneVerification.defaultProps = {
  codeSent: null,
  unsentReason: null,
  notice: null,
};

export default PhoneVerification;
